<template>
	<layout :active.sync="_active" v-bind="{id, name, title}">
		<template slot="header">{{name}}</template>
		<template slot="fields">
			<sectionField v-for="(field, i) in fields" :key="i" v-bind="[field, {sectionId: id}]"/>
		</template>
	</layout>
</template>

<script>
import layout from "./layout.vue";
import sectionField from "./field.vue";

export default {
	components: {layout, sectionField},
	props: {
		id: {type: String, required: true},
		name: {type: String, required: true},
		title: {type: String, required: true},
		fields: {type: Array, required: true},
		active: {type: Boolean, required: false}
	},
	computed: {
		_active: {
			get() {
				return this.active;
			},
			set(active) {
				this.$store.commit("order/sectionActive", {id: this.id, active});
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.section {

}
</style>
